import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  containButton: {
    '& > *': {
      margin: `5px 10px 5px 0`,
    },
  },
}));
